import ValidateForm from "pages/ManagementPage/validations/ValidateForm/ValidateForm";

export default ValidateForm;
